import React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDropdown } from 'src/components/RealityCheckForm/CustomDropdown';
import { GamstopPreviouslyPositiveState } from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.state';
import {
    GAMSTOP_PP_COMMUNICATION_ONLY_MODE_OPTIONS,
    GamstopPpCommunicationOnlyModeType,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.types';
import {
    GamstopPreviouslyPositiveCommunicationOnlyPanelField,
    GamstopPreviouslyPositiveCommunicationOnlyPanelInner,
    GamstopPreviouslyPositiveCommunicationOnlyPanelSection,
    GamstopPreviouslyPositiveCommunicationOnlyPanelWrapper,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.style';

interface GamstopPreviouslyPositiveCommunicationOnlyPanelPropsType {
    state: GamstopPreviouslyPositiveState;
    isVisible: boolean;
}

export const GamstopPreviouslyPositiveCommunicationOnlyPanel = observer(
    ({ state, isVisible }: GamstopPreviouslyPositiveCommunicationOnlyPanelPropsType): JSX.Element => {
        return (
            <GamstopPreviouslyPositiveCommunicationOnlyPanelWrapper
                $isVisible={isVisible}
                data-test='gamstop-pp-communication-only-panel-wrapper'
            >
                <GamstopPreviouslyPositiveCommunicationOnlyPanelInner>
                    <GamstopPreviouslyPositiveCommunicationOnlyPanelSection data-test='gamstop-pp-communication-only-panel'>
                        <GamstopPreviouslyPositiveCommunicationOnlyPanelField>
                            <CustomDropdown
                                dataTest='gamstop-pp-communication-only-mode'
                                hasInternalLabel={false}
                                onChangeCallback={(value): void => {
                                    state.setCommunicationOnlyMode(value);
                                }}
                                optionsList={(): typeof GAMSTOP_PP_COMMUNICATION_ONLY_MODE_OPTIONS =>
                                    GAMSTOP_PP_COMMUNICATION_ONLY_MODE_OPTIONS
                                }
                                placeholder='Select communication type'
                                selectedValue={(): GamstopPpCommunicationOnlyModeType => state.communicationOnlyMode}
                                useMenuPortal={true}
                            />
                        </GamstopPreviouslyPositiveCommunicationOnlyPanelField>
                    </GamstopPreviouslyPositiveCommunicationOnlyPanelSection>
                </GamstopPreviouslyPositiveCommunicationOnlyPanelInner>
            </GamstopPreviouslyPositiveCommunicationOnlyPanelWrapper>
        );
    }
);
